export default __webpack_public_path__ + "static/media/Trey-Kay.be967894.png";